// extracted by mini-css-extract-plugin
export default {"pullQuote":"koranskolene-v0-pullQuote-DEtvH","quoteText":"koranskolene-v0-quoteText-hR5QH","quoteSource":"koranskolene-v0-quoteSource-VSkPL"};